<template>
    <div class="section-box">
        <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="检测时间：">
                <el-radio-group v-model="form.IsAllDay">
                    <el-radio :label="true" border>全天检测</el-radio>
                    <el-radio :label="false" border>自定义检测时间</el-radio>
                </el-radio-group>
                <el-time-picker style="margin-left: 10px;" v-if="!form.IsAllDay" v-model="form.MonitorStartTime"
                    placeholder="开始时间" format="HH:mm" value-format="HH:mm">
                </el-time-picker>
                <el-time-picker style="margin-left: 10px;" v-if="!form.IsAllDay" v-model="form.MonitorEndTime"
                    placeholder="结束时间" format="HH:mm" value-format="HH:mm">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="规则1：" style="">
                <el-radio v-model="form.ActivateStatus1" :label="true">开启</el-radio>
                <el-radio v-model="form.ActivateStatus1" :label="false">关闭</el-radio>
            </el-form-item>
            <el-form-item label="">
                @内部员工超过<el-input v-model="form.AtMinuteCount" style="width:50px;margin:0px 5px;"
                    size="small"></el-input>分钟未回复客户消息的客户群聊
            </el-form-item>
            <el-form-item label="">
                通过企微内部群给通知
                <el-select v-model="form.AdminIdArray1" multiple placeholder="接收人" style="width:350px;">
                    <!-- <el-option v-for="item in adminUserListGroup" :key="item.AdminUserId" :label="item.RealName"
                        :value="item.AdminUserId">
                    </el-option> -->

                    <el-option-group v-for="group in adminUserListGroup" :key="group.label" :label="group.label">
                        <el-option v-for="item in group.options" :key="item.AdminUserId" :label="item.RealName"
                            :value="item.AdminUserId">
                        </el-option>
                    </el-option-group>
                </el-select>
            </el-form-item>
            <el-form-item label="规则2：">
                <el-radio v-model="form.ActivateStatus2" :label="true">开启</el-radio>
                <el-radio v-model="form.ActivateStatus2" :label="false">关闭</el-radio>
            </el-form-item>
            <el-form-item label="">
                客户群无内部人员参与超过<el-input v-model="form.MsgCount" size="small"
                    style="width:50px;margin:0px 5px;"></el-input>条
            </el-form-item>
            <el-form-item label="">
                通过企微内部群给通知
                <el-select v-model="form.AdminIdArray2" multiple placeholder="接收人" style="width:350px;">
                    <!-- <el-option v-for="item in adminUserListGroup" :key="item.AdminUserId" :label="item.RealName"
                        :value="item.AdminUserId">
                    </el-option> -->
                    <el-option-group v-for="group in adminUserListGroup" :key="group.label" :label="group.label">
                        <el-option v-for="item in group.options" :key="item.AdminUserId" :label="item.RealName"
                            :value="item.AdminUserId">
                        </el-option>
                    </el-option-group>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="saveComWxGroupMonitorConfig">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {
    getAdminUser,
} from "@/service/salesStatistics";
import {
    getComWxGroupMonitorConfig, saveComWxGroupMonitorConfig
} from "@/service/run";
export default {
    data() {
        return {
            form: {
                IsAllDay: true,
                MonitorStartTime: '',
                MonitorEndTime: '',

                AtMinuteCount: 10,
                MsgCount: 10,

                ActivateStatus1: true,
                ActivateStatus2: true,

                AdminIdArray1: [],//@内部员工接收人
                AdminIdArray2: []//客户聊天通知速派接收人
            },
            adminUserListGroup: [{
                label: '角色',
                options: [{
                    "AdminUserId": -1,
                    "RealName": "客户群群主"
                }]
            }
            ],
            adminUserList: [
                {
                    "AdminUserId": -1,
                    "RealName": "客户群群主"
                }
            ],
        }
    },
    mounted() {
        this.getAdminUserData();
        this.getComWxGroupMonitorConfig();
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        },

        //获取负责人
        async getAdminUserData() {
            var data = { RoleCodeArray: [] };
            let res = await getAdminUser(data);
            if (res.Result != 1) {
                return this.$message.error(res.Message);
            }
            console.log('res.Data.UserList list:' + JSON.stringify(res.Data.UserList));

            var list = res.Data.UserList.filter(x => {return x.ComWxUserId != ''});

            console.log('getAdminUserData list:' + JSON.stringify(list));
            this.adminUserList = [... this.adminUserList, ...list];

            this.adminUserListGroup.push({
                label: '速派后台账号',
                options: list
            });
        },

        //获取群聊质检的配置信息
        async getComWxGroupMonitorConfig() {
            let res = await getComWxGroupMonitorConfig({});
            if (res.Result != 1) {
                return this.$message.error(res.Message);
            }
            // this.comWxGroupMonitorConfig = res.Data;
            this.form.ActivateStatus1 = res.Data.AtMinuteActivateStatus;
            this.form.AtMinuteCount = res.Data.AtMinuteCount;
            this.form.AdminIdArray1 = res.Data.AtMinuteReceiver || [];

            this.form.ActivateStatus2 = res.Data.CustomerChatActivateStatus;
            this.form.MsgCount = res.Data.MsgCount;
            this.form.AdminIdArray2 = res.Data.CustomerChatReceiver || [];

            this.form.IsAllDay = res.Data.IsAllDay;
            this.form.MonitorStartTime = res.Data.MonitorStartTime;
            this.form.MonitorEndTime = res.Data.MonitorEndTime;

        },
        //保存群聊质检配置
        async saveComWxGroupMonitorConfig() {
            if (this.form.IsAllDay == false) {
                if (this.form.MonitorStartTime == '' || this.form.MonitorEndTime == '') {
                    return this.$message.error('请选择检测时间');
                }
            }
            if (isNaN(this.form.AtMinuteCount)) {
                return this.$message.error('规则1内部员工超过分钟数请输入整数');
            }
            if (this.form.AtMinuteCount <= 0) {
                return this.$message.error('规则1内部员工超过分钟数必须大于0');
            }
            if (this.form.AdminIdArray1.length == 0) {
                return this.$message.error('规则1接收人不能为空');
            }

            if (isNaN(this.form.MsgCount)) {
                return this.$message.error('规则2：客户聊天超过消息数请输入整数');
            }
            if (this.form.MsgCount <= 0) {
                return this.$message.error('规则2：客户聊天超过消息数必须大于0');
            }

            if (this.form.AdminIdArray2.length == 0) {
                return this.$message.error('规则2接收人不能为空');
            }

            console.log('submit form:' + JSON.stringify(this.form));
            var arr = [];
            for (var i = 0; i < this.form.AdminIdArray1.length; i++) {
                var admmin = this.adminUserList.find(x => x.AdminUserId == this.form.AdminIdArray1[i]);
                arr.push({
                    AdminUserId: this.form.AdminIdArray1[i],
                    AdminUserName: admmin ? admmin.RealName : ''
                });
            }
            var arr2 = [];
            for (var i = 0; i < this.form.AdminIdArray2.length; i++) {
                var admmin = this.adminUserList.find(x => x.AdminUserId == this.form.AdminIdArray2[i]);
                arr2.push({
                    AdminUserId: this.form.AdminIdArray2[i],
                    AdminUserName: admmin ? admmin.RealName : ''
                });
            }

            var data = {
                IsAllDay: this.form.IsAllDay,
                MonitorStartTime: this.form.MonitorStartTime,
                MonitorEndTime: this.form.MonitorEndTime,

                AtMinuteCount: this.form.AtMinuteCount,
                MsgCount: this.form.MsgCount,

                ActivateStatus1: this.form.ActivateStatus1,
                ActivateStatus2: this.form.ActivateStatus2,

                AdminIdArray1: arr,//@内部员工接收人
                AdminIdArray2: arr2//客户聊天通知速派接收人
            }
            let res = await saveComWxGroupMonitorConfig(data);
            if (res.Result != 1) {
                return this.$message.error(res.Message);
            }
            this.$message.success('保存成功');
            this.getComWxGroupMonitorConfig();
        },



    }
}
</script>
<style lang="scss" scoped>
.section-box {

    // border: 1px solid red;
    //     padding: 20px 14px;
    //     background-color: #f9fafc;
    //     display: flex;

    //     // align-items: center;
    //     // border:1px solid red;
    //     .el-form-item {
    //         // border:1px solid blue;
    //         margin-bottom: 0 !important;
    //     }

    //     .selected {
    //         color: #409EFF;
    //         border-color: #c6e2ff;
    //         background-color: #ecf5ff;
    //     }
}
</style>